/**
 * Collection Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/collection.liquid
 *
 */

import ProductItem from './product-item.js'
import VueCollapsible from './vue-collapsible.vue'

export default {

  components: {
    ProductItem,
    VueCollapsible
  },

  data () {
    return {
      isLoading: false,
      isSortShown: false,
      isFiltersShown: false,
      headerHeight: null
    }
  },

  watch: {
    isFiltersShown (value) {
      if (value) {
        document.querySelector('body').classList.add('no-scroll')
      } else {
        document.querySelector('body').classList.remove('no-scroll')
      }
    }
  },

  created () {
    this.calaculateHeaderHeight()
  },

  mounted () {
    window.addEventListener('scroll', this.calaculateHeaderHeight)
  },

  methods: {
    submitFilter () {
      this.$refs.filtersForm.submit()
      this.isLoading = true
    },
    showSort () {
      this.$refs.sort.click()
      console.log(this.$refs.sort)
    },
    sort (option) {
      this.$refs.sort.value = option
      this.submitFilter()
    },
    toggleSort () {
      this.isSortShown = !this.isSortShown
    },
    toggleFilter () {
      this.isFiltersShown = !this.isFiltersShown
    },
    clearFilters () {
      // Only on search results page
      // Remove all search parameters
      window.location = window.location.href.split('&')[0]
    },
    initiateSearch (event) {
      if (event) {
        window.location = `/search?q=${event.target.value}`
      } else {
        window.location = `/search?q=${this.$refs.searchInput.value}`
      }
    },
    calaculateHeaderHeight () {
      const header = document.querySelector('.header-wrapper')

      this.headerHeight = header.getBoundingClientRect().top + header.offsetHeight
    }
  }
}
